import { gql } from '@apollo/client'

export const ADD_MAGAZINE = gql`
    mutation addMagazine($input: addEntityInput!) {
        addEntity(input: $input) {
            success
            entity {
                guid
                ... on Magazine {
                    title
                    url
                }
            }
        }
    }
`

export const EDIT_MAGAZINE = gql`
    mutation editMagazine($input: editEntityInput!) {
        editEntity(input: $input) {
            success
            entity {
                guid
                ... on Magazine {
                    title
                    url
                }
            }
        }
    }
`
